import {
  Dispatch,
  RefObject,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import {
  Theme,
  ThemeContext,
  ThemeContextType,
} from '../../../contexts/ThemeContext/ThemeContext';
import { INotfisResponse } from '../../../interfaces/response/Notfis/INotfisResponse';
import { IPrintOrderTagModalHandle } from '../components/PrintOrderTagModal/PrintOrderTagModal';

export interface UseCheckOrders {
  disableAutoSubmit: boolean;
  setDisableAutoSubmit: Dispatch<SetStateAction<boolean>>;
  submitToPrinter: (auto: boolean) => Promise<void>;
  openModalWithTag: (tag: INotfisResponse) => void;
  printModalRef: RefObject<IPrintOrderTagModalHandle>;
  theme: Theme;
  setNfKey: Dispatch<SetStateAction<string>>;
  navigate: NavigateFunction;
  nfKey: string;
  addPrintedOrder: (printedOrder: INotfisResponse) => void;
  printedOrdersArray: INotfisResponse[];
  tipoCarga: ECargoType;
  setTipoCarga: Dispatch<SetStateAction<ECargoType>>;
}

export enum ECargoType {
  Entrega,
  Coleta,
}

const useCheckOrders = (): UseCheckOrders => {
  const [disableAutoSubmit, setDisableAutoSubmit] = useState<boolean>(false);
  const [tipoCarga, setTipoCarga] = useState<ECargoType>(ECargoType.Entrega);
  const [nfKey, setNfKey] = useState<string>('');
  const printModalRef = useRef<IPrintOrderTagModalHandle>(null);
  const { theme } = useContext<ThemeContextType>(ThemeContext);
  const navigate = useNavigate();
  const [printedOrdersArray, setPrintedOrdersArray] = useState<
    INotfisResponse[]
  >([]);

  const addPrintedOrder = (printedOrder: INotfisResponse): void => {
    // if (printedOrder.cubagem !== null) setNfKey('');
    setPrintedOrdersArray((array) => [printedOrder, ...array]);
  };

  const submitToPrinter = async (auto: boolean): Promise<void> => {
    printModalRef.current?.openModalToPrint(nfKey, auto);
  };

  const openModalWithTag = (tag: INotfisResponse): void => {
    printModalRef.current?.openModal(tag);
  };

  // Validate auto-submit
  useEffect(() => {
    handlePrintTag();
  }, [nfKey]);

  const handlePrintTag = (): void => {
    // Padrão para etiquetas da Casas Bahia: somente números
    const casasBahiaRegex = /^\d+$/;

    // Padrão para etiquetas da Kabum: combina números e letras
    const kabumRegex = /^[A-Za-z0-9]+$/;

    if (nfKey.length === 29 && nfKey.startsWith('4370') && !disableAutoSubmit) {
      submitToPrinter(true);
      return;
    }

    // PADRAO DE CONSULTA AUTOMATICA DA CASAS BAHIA
    if (
      nfKey.length === 9 &&
      !nfKey.startsWith('4370') &&
      casasBahiaRegex.test(nfKey) &&
      !disableAutoSubmit
    ) {
      submitToPrinter(true);
      return;
    }

    // PADRAO DE CONSULTA AUTOMATICA DA KABUM
    if (
      nfKey.length === 13 &&
      kabumRegex.test(nfKey) &&
      !disableAutoSubmit &&
      !nfKey.startsWith('4370')
    ) {
      submitToPrinter(true);
    }
  };

  return {
    disableAutoSubmit,
    setDisableAutoSubmit,
    theme,
    navigate,
    setNfKey,
    submitToPrinter,
    printModalRef,
    nfKey,
    addPrintedOrder,
    printedOrdersArray,
    openModalWithTag,
    tipoCarga,
    setTipoCarga,
  };
};

export default useCheckOrders;
